import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import { pauseSubscription } from "../../Screens/Accounts/AccountSettings/service";
import Translate from "../MultiLanguage/Translate";

const PauseSubscriptionModal = ({ setPauseSubModal, subId, onPauseSuccess }) => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const [loading, setLoading] = useState(false);
  const [pauseError, setPauseError] = useState(null);
  const [pauseDuration, setPauseDuration] = useState("1");

  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };

  const handlePause = async () => {
    setLoading(true);
    setPauseError(null);
    try {
      const response = await pauseSubscription(appInfo, subId, pauseDuration);
      if (response?.status === 200) {
        toast.success(<Translate textKey={'subscription_pause'} />, {
          position: "bottom-center",
        });
        setPauseSubModal(false);
        if (onPauseSuccess) onPauseSuccess();
      } else {
        setPauseError(response?.data?.message || "Failed to pause subscription.");
      }
    } catch (err) {
      setPauseError(err.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pauseSubscriptionModal">
      <div className="overlayModal"></div>
      <div className="pauseSubscriptionContainer">
        <div className="closePauseContainer" onClick={() => setPauseSubModal(false)}>
          <CloseIcon />
        </div>
        <h1 htmlFor="pauseDuration" className="pause-label">
          <Translate textKey="pause_subscription" defaultText="Pause Subscription" />
        </h1>
        <select
          className="pause-modal-select"
          id="pauseDuration"
          value={pauseDuration}
          onChange={e => {
            setPauseDuration(e.target.value);
            setPauseError(null);
          }}
          disabled={loading}
        >
          <option value=""><Translate textKey={'select_duration'} /></option>
          <option value="1">For 1 Month</option>
          <option value="2">For 2 Months</option>
          <option value="3">For 3 Months</option>
          <option value="4">For 4 Months</option>
          <option value="5">For 5 Months</option>
          <option value="6">For 6 Months</option>
        </select>
        {pauseError && (
          <span className="pause-error">{pauseError}</span>
        )}
        <div className="pause-btn-row">
          <div
            className="buttonContainer"
            onClick={e => {
              if (!pauseDuration) {
                setPauseError('Please select a pause duration.');
                return;
              }
              handlePause();
            }}
            style={{ pointerEvents: loading ? 'none' : 'auto' }}
          >
            <div className="background pause"></div>
            <button disabled={loading}>
              {loading ? (
                <Translate textKey="pausing" defaultText="Pausing..." />
              ) : (
                <Translate textKey="confirm_pause" defaultText="Pause Subscription" />
              )}
            </button>
          </div>
          <div
            className="buttonContainer"
            onClick={() => setPauseSubModal(false)}
            style={{ pointerEvents: loading ? 'none' : 'auto' }}
          >
            <div className="background cancel"></div>
            <button disabled={loading}>
              <Translate textKey="cancel" defaultText="Cancel" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PauseSubscriptionModal;
